import type { FaireProductEntity } from "../../entity_types/product";

export const p_34d7kt6smr: FaireProductEntity = {
  token: "p_34d7kt6smr",
  type: "product",
  name: "Dried Flowers - Field Bouquet - Natural",
  brandToken: "b_4qm8pqu56k",
  brandName: "Wildflowers by Floriette",
  imageUrl:
    "https://cdn.faire.com/fastly/44de9440c4be0efbe8b09f224853a71c067e7c29892b61e9321e406d7fadbacc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/763f72301e027809cc2c654b1a3829acd8b48c4080375b7f2905d9020d7acd35.jpeg",
    "https://cdn.faire.com/fastly/16080cbedd66cc9786430c710ff1892f043eef7dacceaa21e02c53775246a6fc.png",
    "https://cdn.faire.com/fastly/24d2c47e89bf04b304d1eaa4b3881ec2a1a46db6ddc461a8b79425121dc22106.jpeg",
    "https://cdn.faire.com/fastly/5505535c44c760fa76b2cf878b0901fa2f36e5fa891cba08123d6ff46774729c.jpeg",
    "https://cdn.faire.com/fastly/7f299c50ee3b585f065e3e81319ac9cef24e634a5327132ff3463eb24c054047.jpeg",
    "https://cdn.faire.com/fastly/a57a5872e39f1740404f3eb649da13f3b5172da56537f1d92f6199df1a1a9b5e.png",
    "https://cdn.faire.com/fastly/f50ce0831b50b6a416d70dbcb8a74cf007f608e710ff3e67ae3b7a07810ee693.png",
    "https://cdn.faire.com/fastly/08b1e986151143c9462e4b56bde366a6ab8b5897f4b16913eb931a607af27663.jpeg",
    "https://cdn.faire.com/fastly/a2ed2e504aaf4662a1f11f77f951937dc6bd06a09418f746f86504ff05ec92a5.jpeg",
    "https://cdn.faire.com/fastly/1e03796ca3111132c7e969464383d4ff3cebcfdb18d15911039423516bfab994.jpeg",
  ],
  priceDollars: 15,
  description:
    "Introducing our exquisite Dried Flowers Field Bouquet Natural. Enrich your space with the beauty of dried flowers, carefully handcrafted and sustainably grown for a touch of eco-conscious elegance. Each piece is thoughtfully curated with love, resulting in a stunning composition that captures the essence of natural beauty. These charming bouquets are also available in Small, Medium and Large.\n\nPlease note that dried flowers are natural and seasonal products, which may lead to variations in flower types and colors compared to the photo. Embrace the surprises that come with these ever-changing botanical wonders and add a touch of enchantment to any environment.\n\nSmall: 35 cm\nMedium: 50 cm\nLarge: 60 cm",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:35.152Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
